import * as React from 'react';
import { Grid, FormControl, FormGroup, Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import { updateQuestionDataValue } from 'src/effects/utils/preview';
import { SurveyStatusEnum } from 'src/constants/Enum/SurveyStatusEnum';

export default class CheckboxTypeQuestionComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
        };

        this.onAnswerChange = this.onAnswerChange.bind(this);
    }

    setLocalState(props: any, isComponentDidMount: boolean) {
        for (let classType: number = 1; classType <= props.question.class_type; classType++) {
            const otherText = props.question.question_responses[classType - 1].other_text;
            const stateResponseString = JSON.stringify(this.state[props.pageNumber + '_' + props.questionId + "_" + classType]); 
            const questionResponse = props.question.question_responses[classType - 1];
             
            if (isComponentDidMount && (props.isReviewQuetion || !props.isResponsePage) && questionResponse && questionResponse.value && Array.isArray(questionResponse.value)) {

                const response = props.question.default_question_responses.find((resp: any) => resp.class_type === classType);
                if (response && response.value) {
                    const value = questionResponse.value.map((currentValue: any) => {
                        const option = response.value.find((r: any) => r.key.value === currentValue.key.value);
                        currentValue.value = option && option.value;

                        return currentValue;
                    });

                    questionResponse.value = value;
                }
             } 

            const propsResponseString = JSON.stringify(questionResponse.value); 
 
            if (stateResponseString !== propsResponseString
                || this.state[props.pageNumber + '_' + props.questionId + "_" + classType + "_other_text"] !== otherText) {
                this.setState({
                    [props.pageNumber + '_' + props.questionId + "_" + classType]: questionResponse.value,
                    [props.pageNumber + '_' + props.questionId + "_" + classType + "_other_text"]: (otherText === undefined || otherText === null) ? null : otherText
                })
            }
        }
    }

    componentDidMount() {
        this.setLocalState(this.props, true);
    }

    componentWillReceiveProps(nextProps: any) {
        this.setLocalState(nextProps, false);
    }

    onAnswerChange(classType: any, event: any) {
        const questionState: any = this.props.question.question_responses[classType - 1].value;
        const questionStateString = JSON.stringify(questionState);
        const questionStateObject = JSON.parse(questionStateString);
        for (const item of questionStateObject) {
            if (event.target.value === item.key.value) {
                item.value = event.target.checked;
            }
        }

        this.setState({ [event.target.name]: questionState });
        if (!this.props.isReviewQuetion) {
            updateQuestionDataValue(this.props, classType, questionStateObject, null, this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + classType + "_other_text"], true, []);
        }
    }

    onOtherTextChange(classType: any, event: any) {
        this.setState({ [event.target.name]: event.target.value });
    }

    onOtherTextBlur(classType: any, event: any) {
        if (!this.props.isReviewQuetion) {
            updateQuestionDataValue(this.props, classType, this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + classType], null, event.target.value, true, []);
        }
    }

    renderQuestion() {
        const elements: any = [];
        if (this.props && this.props.question.class_type !== undefined) {
            for (let classType: number = 1; classType <= 3; classType++) {

                elements.push(
                    <Grid key={this.props.pageNumber + '_lable_' + this.props.questionId + "_" + classType} item={true} sm={4} className="pb-0">
                        <div className="checkboxGroupControl">
                            <FormControl margin="normal" fullWidth={true}>
                                <FormGroup className="checkboxGroup" row={true}>
                                    <label>
                                        {
                                            classType === 1 ?
                                                (this.props.question.question_one_title ? this.props.question.question_one_title.en : '') :
                                                classType === 2 ?
                                                    (this.props.question.question_two_title ? this.props.question.question_two_title.en : '')
                                                    :
                                                    (this.props.question.question_three_title ? this.props.question.question_three_title.en : '')
                                        }
                                    </label>
                                </FormGroup>
                            </FormControl>
                        </div>
                    </Grid>
                )
            }
            for (let classType: number = 1; classType <= this.props.question.class_type; classType++) {
                const defaultQuestionResponses = this.props.question.default_question_responses && this.props.question.default_question_responses.find((resp: any) => resp.class_type === classType);        
                const isEditable = this.props.isResponsePage && this.props.surveyType === 1 ? true : defaultQuestionResponses && (defaultQuestionResponses.value || (defaultQuestionResponses.value + '').length > 0) ? defaultQuestionResponses.is_Editable : true;     

                elements.push(
                    <Grid key={this.props.pageNumber + '_' + this.props.questionId + "_" + classType} item={true} sm={4} className="pt-0">
                        <div className="checkboxGroupControl">
                            <FormControl margin="normal" fullWidth={true} className="mt-0">
                                <FormGroup className="checkboxGroup" row={true}>
                                    {
                                        this.props.question.items[classType - 1].choices.map((item: any, key: any) => { 
                                            return <FormControlLabel key={key}
                                                control={
                                                    <Checkbox
                                                        key={key}
                                                        name={this.props.pageNumber + '_' + this.props.questionId + "_" + classType}
                                                        checked={
                                                            this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + classType] !== undefined ?
                                                                (this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + classType][key] !== undefined ?
                                                                    this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + classType][key].value : false) :
                                                                false
                                                        }
                                                        onChange={this.onAnswerChange.bind(this, classType)}
                                                        value={item.value}
                                                        color="primary"
                                                        disabled={this.props.surveyStatus === SurveyStatusEnum.Finished || !isEditable}
                                                    />
                                                }
                                                label={item.text.en}
                                            />
                                        })
                                    }
                                    {
                                        this.props.question.show_other_textbox &&
                                        this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + classType + "_other_text"] !== undefined &&
                                        <TextField
                                            label={"Other Text"}
                                            margin="normal"
                                            variant="outlined"
                                            name={this.props.pageNumber + '_' + this.props.questionId + "_" + classType + "_other_text"}
                                            autoFocus={false}
                                            value={this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + classType + "_other_text"]}
                                            onChange={this.onOtherTextChange.bind(this, classType)}
                                            onBlur={this.onOtherTextBlur.bind(this, classType)}
                                            disabled={ this.props.surveyStatus === SurveyStatusEnum.Finished}
                                        />
                                    }
                                </FormGroup>
                            </FormControl>
                        </div>
                    </Grid>
                );
            }
        }
        return elements;
    }

    render() {
        return (
            <>
                {
                    this.renderQuestion()
                }
            </>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/responses/QuestionTypes/CheckboxTypeQuestionComponent.tsx